import axiosInstance from "../../../common/axios/axsiosInstance";

export async function getOrganizationMembers(setErrorModalShow) {
  try {
    const response = await axiosInstance.get("/user/organization/members");

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response?.data?.status === 404) {
      const errorMessage = getErrorMessage(error);

      setErrorModalShow({
        message: errorMessage,
      });
    }

    console.error("Failed to fetch organization members:", error);
    throw error;
  }
}
const getErrorMessage = (error) => {
  if (error.response) {
    const status = error.response.status;
    const serverMessage = error.response.data?.message;

    const statusMessages = {
      400: "Please check your input and try again",
      401: "Please log in again",
      403: "You don't have permission for this",
      409: "This already exists",
      422: "Please check your input",
      429: "Too many requests, please wait",
      500: "Server error, please try again",
    };

    return serverMessage || statusMessages[status] || "Something went wrong";
  }

  if (error.request) {
    return "Network error, please check your connection";
  }
  return "An unexpected error occurred";
};
